// extracted by mini-css-extract-plugin
export default {"loader":"Form_loader__3tQJl"};